<section class="flex flex-col items-center gap-3.5 rounded-xl border border-border bg-card px-8 py-20 text-center shadow-sm">
    <span class="grid size-[74px] place-items-center rounded-full bg-brand-studio/10 text-brand-studio-dark dark:text-brand-studio">
        @switch (icon()) {
        @case ('flag') {
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
            <line x1="4" x2="4" y1="22" y2="15" />
        </svg>
        }
        @case ('file-text') {
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
            <path d="M16 13H8" />
            <path d="M16 17H8" />
        </svg>
        }
        @default {
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
            <circle cx="9" cy="9" r="2" />
            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
        </svg>
        }
        }
    </span>

    <h3 class="mt-1.5 font-heading text-[34px] font-extrabold leading-none tracking-[-0.025em] text-foreground">
        {{ heading() }}
    </h3>

    @if (body()) {
    <p class="m-0 max-w-[52ch] text-sm leading-relaxed text-foreground/80">{{ body() }}</p>
    }

    @if (badge()) {
    <span class="mt-1.5 rounded-full bg-brand-studio/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-brand-studio-dark dark:text-brand-studio">
        {{ badge() }}
    </span>
    }
</section>
